import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import Dashboard from 'portal/src/components/common/Dashboard';
import { DASHBOARD_SLUGS } from 'portal/src/constants/luzmoDashboards';
import InverseModelDashboard from 'portal/src/pages/usage/InverseModelDashboard';
import isInverseModelDashboardEnabled from 'portal/src/pages/usage/isInverseModelDashboardEnabled';

import { RouteDefinition } from './routeGenerator';

export const usageRouteDefinitions: RouteDefinition[] = [
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.ELECTRIC} />,
    name: 'Electric',
    path: NESTED_ROUTES.USAGE.ELECTRIC,
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.GAS} />,
    name: 'Gas',
    path: NESTED_ROUTES.USAGE.GAS,
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.WATER} />,
    name: 'Water',
    path: NESTED_ROUTES.USAGE.WATER,
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.ALL_UTILITIES} />,
    name: 'All Utilities',
    path: NESTED_ROUTES.USAGE.ALL_UTILITIES,
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.YEAR_OVER_YEAR} />,
    name: 'Year-over-Year',
    path: NESTED_ROUTES.USAGE.YEAR_OVER_YEAR,
  },
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.YEAR_OVER_YEAR_BAR} />
    ),
    name: 'Year-over-Year Bar',
    path: NESTED_ROUTES.USAGE.YEAR_OVER_YEAR_BAR,
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.TEMPERATURE} />,
    name: 'Temperature',
    path: NESTED_ROUTES.USAGE.TEMPERATURE,
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.WEATHER} />,
    name: 'Weather',
    path: NESTED_ROUTES.USAGE.WEATHER,
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.ENERGY_KBTU} />,
    name: 'Energy (KBTU)',
    path: NESTED_ROUTES.USAGE.ENERGY_KBTU,
  },
  {
    element: (
      <Dashboard
        dashboardSlug={DASHBOARD_SLUGS.USAGE.WEATHER_NORMALIZED_USAGE}
      />
    ),
    name: 'Weather Normalized Usage',
    path: NESTED_ROUTES.USAGE.WEATHER_NORMALIZED_USAGE,
  },
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.PROJECT_SAVINGS} />
    ),
    name: 'Project Savings',
    path: NESTED_ROUTES.USAGE.PROJECT_SAVINGS,
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.USAGE.DEMAND} />,
    name: 'Demand',
    path: NESTED_ROUTES.USAGE.DEMAND,
  },
  {
    element: (
      <InverseModelDashboard slug={DASHBOARD_SLUGS.USAGE.INVERSE_MODELS} />
    ),
    name: 'Inverse Models',
    path: NESTED_ROUTES.USAGE.INVERSE_MODELS,
    shouldRenderLink: isInverseModelDashboardEnabled,
  },
];
